module.exports = {
  toString(obj) {
    let str = '';
    let i = 0;
    for (const [k, v] of Object.entries(obj)) {
      const vEncoded = encodeURIComponent(v);
      const vSpacesRemoved =
        typeof v === 'string' ? vEncoded.replace(/%20/g, '+') : vEncoded;
      str += i === 0 ? `${k}=${vSpacesRemoved}` : `&${k}=${vSpacesRemoved}`;
      i++;
    }
    return str;
  },
};
